export default __webpack_public_path__ + "static/media/icon_delete 2.0968f30e.svg";